import { AppServices } from '@singularsystems/neo-core';
import Types from './AuthorisationTypes';
import AuthorisationDataCache from './Services/AuthorisationDataCache';
import UserGroupsVM from './Views/UserGroupsVM';
import { UserRolesHub } from './Services/ApiClients/UserRolesHub';
import AuthorisationApiClient from './Services/ApiClients/AuthorisationApiClient';
import AssignedRolesApiClient from './Services/ApiClients/AssignedRolesApiClient';
import MembershipsApiClient from './Services/ApiClients/MembershipsApiClient';
import ResourcesApiClient from './Services/ApiClients/ResourcesApiClient';
import UserGroupsApiClient from './Services/ApiClients/UserGroupsApiClient';
import UsersApiClient from './Services/ApiClients/UsersApiClient';
import AuthorisationManagementService from './Services/AuthorisationManagementService';

// Modules
const AuthorisationAppModule = new AppServices.Module("Authorisation", container => {
    // Api Clients
    container.bind(Types.ApiClients.AuthorisationApiClient).to(AuthorisationApiClient).inSingletonScope();
    container.bind(Types.ApiClients.AssignedRolesApiClient).to(AssignedRolesApiClient).inSingletonScope();
    container.bind(Types.ApiClients.MembershipsApiClient).to(MembershipsApiClient).inSingletonScope();
    container.bind(Types.ApiClients.ResourcesApiClient).to(ResourcesApiClient).inSingletonScope();
    container.bind(Types.ApiClients.UserGroupsApiClient).to(UserGroupsApiClient).inSingletonScope();
    container.bind(Types.ApiClients.UsersApiClient).to(UsersApiClient).inSingletonScope();
    container.bind(Types.ApiClients.UserRolesHub).to(UserRolesHub).inSingletonScope();

    // Services
    container.bind(Types.Services.AuthorisationDataCache).to(AuthorisationDataCache).inSingletonScope();
    container.bind(Types.Services.AuthorisationManagementService).to(AuthorisationManagementService).inSingletonScope();

    // View Models
    container.bind(Types.ViewModels.UserGroupsViewModel).to(UserGroupsVM).inTransientScope();
});

const authorisationTestModule = new AppServices.Module("Authorisation", container => {
    // bind test types
});

// Routes
// const SecurityRoute: Routing.IMenuRoute =
// {
//     // name: "User Access", path: "/security/useraccess", component: UserGroupsView, icon: "unlock-alt",
//     // role: Roles.UserAccess.Access (TODO: Uncomment once back-end UserManagement roles have been investigated after showcase),
// }

// role: Roles.UserAccess.Access

export {
    AuthorisationAppModule,
    authorisationTestModule,
    // SecurityRoute
}
